import CardHeader from "components/CardHeader";
import { Invoice } from "models/Invoice";
import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Card, CardBody } from "reactstrap";
import * as api from "services/Api";
import { useOfficeTranslation } from "i18n/OfficeTranslation";

const initialInvoiceCount = 10;

const AccountInvoicesCard: React.FC<{ accountId: string }> = ({ accountId }) => {
    const { intlLocale, t } = useOfficeTranslation();
    const [invoices, setInvoices] = useState<Invoice[]>([]);
    const [visibleCount, setVisibleCount] = useState(initialInvoiceCount);
    useEffect(() => {
        setVisibleCount(initialInvoiceCount);
        api.getInvoices().then(items => setInvoices((items ?? [])
            .filter(invoice => invoice.customer === accountId && !invoice.quote)
            .sort((a, b) => b.GetCreatedDate().getTime() - a.GetCreatedDate().getTime())
        ));
    }, [accountId]);
    const visibleInvoices = useMemo(() => invoices.slice(0, visibleCount), [invoices, visibleCount]);
    const remaining = Math.max(0, invoices.length - visibleInvoices.length);

    return <Card>
        <CardBody>
            <CardHeader title={t("common.invoices")} icon="mdi-file-document-outline" count={invoices.length} />
            {visibleInvoices.map(invoice => <div
                className="d-flex justify-content-between align-items-center gap-3 border-bottom py-3"
                key={invoice.id}
            >
                <div className="min-w-0">
                    <Link to={`/invoice/${invoice.id}`} className="fw-semibold text-truncate d-block">
                        {invoice.GetDisplayName() || invoice.id}
                    </Link>
                    <small className="text-muted">{invoice.GetCreatedDate().toLocaleDateString(intlLocale)}</small>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-3 flex-shrink-0">
                    {invoice.IsPaid()
                        ? <span className="badge bg-success bg-soft text-success">{t("common.paid")}</span>
                        : invoice.draft
                            ? <span className="badge bg-light text-muted">{t("common.draft")}</span>
                            : <span className="badge bg-warning bg-soft text-warning">{t("common.open")}</span>}
                    <span className="text-end" style={{ minWidth: 80 }}>€ {invoice.CalcGrandTotal().toFixed(2)}</span>
                </div>
            </div>)}
            {remaining > 0 && <Button
                color="light"
                className="w-100 mt-3"
                type="button"
                onClick={() => setVisibleCount(invoices.length)}
            >{t("accounts.accountInvoicesCard.showCountMoreInvoices", {count: remaining})}</Button>}
            {!invoices.length && <p className="text-muted mt-3 mb-0">{t("accounts.accountInvoicesCard.noInvoicesLinkedToThisAccount")}</p>}
        </CardBody>
    </Card>;
};
export default AccountInvoicesCard;
